import { readMe, readUsers } from './read'
import { readUser } from './readSingle'

export const users = {
  readMe,
  read: readUsers,
  readSingle: readUser,
}
